import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';
import { createElement } from 'react';
import { rootRouteRef } from './routes';
import PublishIcon from '@material-ui/icons/Publish';

const ReleaseManagerPage = PageBlueprint.make({
  params: {
    path: '/release-manager',
    routeRef: rootRouteRef,
    title: 'Release Manager',
    icon: createElement(PublishIcon),
    loader: async () => {
      const { ReleaseManager } = await import('./module/releaseManager');
      return createElement(ReleaseManager);
    },
  },
});

const releaseManagerPlugin = createFrontendPlugin({
  pluginId: 'release-manager',
  extensions: [ReleaseManagerPage],
  routes: {
    root: rootRouteRef,
  },
});

export default releaseManagerPlugin;
